module.exports = __webpack_public_path__ + "img/drag-to-answer-white.2dde2ffd.png";